import { useContext } from 'react';
import { QueryFunctionContext, useQuery } from 'react-query';
import { assignment_api } from '@axo/shared/data-access/api';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { queryFunction } from '../../query-function';
import {
  applicationAssignmentKeys,
  parseApplicationAssignmentKey,
} from '../../cache-keys/applicationAssignmentKeys';

function assignmentParams({
  queryKey,
}: QueryFunctionContext<
  ReturnType<(typeof applicationAssignmentKeys)['root']>
>) {
  const { applicationID, marketCountry } =
    parseApplicationAssignmentKey(queryKey);
  return {
    LoanApplicationID: applicationID ?? '',
    Country: marketCountry,
  };
}

export function useAssignment(
  marketCountry: string,
  applicationID: string,
  options?: { enabled?: boolean },
) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = applicationAssignmentKeys.root({
    applicationID,
    marketCountry,
  });
  return useQuery(
    cacheKey,
    queryFunction(assignment_api.find(api), assignmentParams),
    {
      enabled:
        state.user.token.length > 0 &&
        applicationID !== '' &&
        (options?.enabled ?? true),
      select: (result) => result?.Items[0],
    },
  );
}
